import Cookies from "js-cookie";

export const getUid = ()=>Cookies.get("user_id");
export const getAccesstoken = ()=>Cookies.get("access_token");
export const getFirstname = ()=>Cookies.get("firstname");
export const getSurname = ()=>Cookies.get("lastname");


export const setCookie =(name, value, expires=7, path="")=>{
    Cookies.set(name, value, { expires, path });
};

export const removeCookie =(name)=>{
    Cookies.remove(name);
};

export const setMtvCookies =(data)=>{
    setCookie("access_token", data?.access_token);
    setCookie("user_id", data?.user_id);      
    if(data?.firstname) setCookie("firstname", data?.firstname);  
    if(data?.surname) setCookie("lastname", data?.surname);  
}

export const removeMtvCookies =(data)=>{
    removeCookie("access_token");
    removeCookie("user_id");
    removeCookie("firstname");
    removeCookie("lastname");
}